<template>
  <div :class="'w-full col-span-full '+grid">
    <div :class="passwordInputSize">
      <input-text
        name="password"
        type="password"
        libelle="Changer de mot de passe"
        :new-password="true"
        :value="password"
        @input="
          (newValue) => {
            $emit('fillPassword', newValue);
          }
        "
        :error="true"
        :msg-error="((errors || {}).password || [])[0]"
      />
      <p
        id="change-password"
        class="text-sm text-pink-600 italic mt-1.5 cursor-pointer"
        @click="displayAuthenticateField"
      >
        Modifier le mot de passe
      </p>
    </div>
    <input-text
      v-if="isAuthenticateAsk"
      :class="confirmPasswordInputSize"
      name="password_confirmation"
      type="password"
      libelle="Confirmer le nouveau mot de passe"
      :value="confirmPassword"
      @input="
        (newValue) => {
          $emit('fillConfirmPassword', newValue);
        }
      "
    />
    <input-text
      :class="authPasswordInputSize"
      v-if="isAuthenticateAsk"
      name="authPassword"
      type="password"
      libelle="Mot de passe pour authentification"
      placeholder="Entrer votre mot de passe actuel"
      :value="authPassword"
      @input="
        (newValue) => {
          $emit('fillAuthPassword', newValue);
        }
      "
      :error="true"
      :msg-error="((errors || {}).authPassword || [])[0]"
    />
    <div
      v-if="isAuthenticateAsk"
      :class="confirmButtonSize"
    >
      <div class="text-sm text-gray-600 mb-2">
&nbsp;
      </div>
      <action-button
        class="mb-1"
        border-color="border-transparent"
        text-color="text-white"
        bg-color="bg-indigo-600"
        libelle="Enregistrer le nouveau mot de passe"
        :uppercase="true"
        type-shadow="shadow-indigo"
        @clickAction="$emit('confirmNewPassword')"
      />
    </div>
  </div>
</template>

<script>
import InputText from './InputText.vue';
import ActionButton from './../ActionButton.vue';

export default {
  components: {
    InputText,
    ActionButton,
  },

  props: {
    grid: {
      type: String,
      required: false,
      default: 'grid grid-cols-12',
    },
    passwordInputSize: {
      type: String,
      required: false,
      default: 'col-span-6',
    },
    confirmPasswordInputSize: {
      type: String,
      required: false,
      default: 'col-span-6',
    },
    authPasswordInputSize: {
      type: String,
      required: false,
      default: 'col-span-6',
    },
    confirmButtonSize: {
      type: String,
      required: false,
      default: 'col-span-6',
    },
    password: {
      type: String,
      required: true,
      default: '',
    },
    confirmPassword: {
      type: String,
      required: true,
      default: '',
    },
    authPassword: {
      type: String,
      required: true,
      default: '',
    },
    errors: {
      type: Object,
      required: false,
      default: {},
    },
  },

  data() {
    return {
      isAuthenticateAsk: false,
    };
  },

  methods: {
    displayAuthenticateField() {
      this.isAuthenticateAsk = !this.isAuthenticateAsk;
    },
  },
};
</script>
